module.exports = __webpack_public_path__ + "static/media/icon-intersection.ed70d792.svg";